import { render, staticRenderFns } from "./PageEmailConfirm.vue?vue&type=template&id=5c90ea68&"
import script from "./PageEmailConfirm.vue?vue&type=script&lang=ts&"
export * from "./PageEmailConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports